// Authentication Service
// Handles all authentication-related API calls using axios
import { api } from './api.js';

class AuthService {
  // Register new user
  async register(userData) {
    const response = await api.post('/auth/register', userData);
    return response.data;
  }

  // Login user
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    // Cookies are automatically set by backend, no localStorage needed
    return response.data;
  }

  // Logout user
  async logout() {
    await api.post('/auth/logout');
    // Backend clears cookies automatically
  }

  // Refresh access token
  async refreshToken() {
    const response = await api.post('/auth/refresh');
    return response.data;
  }

  // Get current user (stored in cookies, no localStorage)
  getCurrentUser() {
    // This will be handled by backend via cookies
    return null;
  }

  // Get access token (not needed, cookies handle this)
  getAccessToken() {
    return null;
  }

  // Check if user is authenticated (backend will validate via cookies)
  isAuthenticated() {
    // This should be checked via API call, not localStorage
    return false;
  }

  // Check if user is admin
  isAdmin() {
    // Should be checked via API call
    return false;
  }

  // Get user profile
  async getProfile() {
    const response = await api.get('/auth/profile');
    return response.data.data.user;
  }

  // Update user profile
  async updateProfile(userData) {
    const response = await api.put('/auth/profile', userData);
    return response.data.data.user;
  }
}

export default new AuthService();
